"use client";

import dynamic from "next/dynamic";
import { observer } from "mobx-react";
import { useStores } from "../../../stores/useStores";
import {
  siteAssistantSession,
  updateSiteAssistantSession,
} from "./siteAssistantSession";

const SiteAssistant = dynamic(() => import("./SiteAssistant"));

/** The Site Assistant's floating window, open or closed from the AdminMenu's button; loaded only once opened. */
export const SiteAssistantWindow = observer(() => {
  const { userStore } = useStores();

  return userStore.isEditor && siteAssistantSession.open ? (
    <SiteAssistant
      onClose={() => updateSiteAssistantSession({ open: false })}
    />
  ) : null;
});
